import React from 'react'
import styles from './about.module.scss'
import MyPicture from './img/mypicture.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faLanguage , faSchool , faStar, faEnvelope , faGraduationCap , faLocationDot , faEarthAmericas , faUserSecret , faLaptopCode , faPhoneVolume} from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import SectionBorderPtBr from '../Section-Border-pt-br'
import ZipButtonFilePtBr from '../Zip-File-Convertion-pt-br'

export default function AboutPtBr() {

    return (
        <>
        <SectionBorderPtBr />
            <section className={styles.container} id="about">
                <div className={classNames(styles.divisionTitle, 'scroll_bottom')}>
                    <p className={styles.paragraphTitle}>Deixe-me apresentar</p>
                    <h2 className={styles.title}>Sobre Mim</h2>
                        <div className={styles.divisionDot} aria-label='Section-illustrators-dots'>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                        </div>
                </div>

                <div className={classNames(styles.imageDivision, 'scroll_scale')}>
                    <img className={styles.myPicture} src={MyPicture} alt="" />
                </div>

                <div className={classNames(styles.divisionIntroduction, 'scroll_scale' )}>
                    <h3 className={styles.titleIntroduce}>Olá, eu sou <span style={{fontFamily: 'Berkshire Swash, cursive', fontWeight: '500'}}>Marcos Maio</span></h3>
                    <p className={styles.paragraphIntroduce}>
                        Eu sou um estudante de desenvolvimento de aplicações web, especificamente um desenvolvedor front-end, atualmente tenho trabalhando em meus próprios projetos enquanto estudo para aprender mais e melhorar minhas habilidades.
                    </p>
                    <p className={styles.paragraphIntroduce}>
                        Atualmente estou cursando graduação em Análise e Desenvolvimento de Sistemas, e por isso atualmente busco emprego na área de desenvolvimento web em uma empresa que possa me passar confiança e me ajudar a me desenvolver-me melhor como profissional.
                    </p>
                    <div className={styles.informationDivision}>
                        <p className={styles.info} > <FontAwesomeIcon icon={faCalendarDays} style={{color: "#4d4d4d",}} /> Data De Aniversário: <span>07/26/2002</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)}> <FontAwesomeIcon icon={faLocationDot} style={{color: "#4d4d4d",}} /> Endereço:<span>Rio De Janeiro , Brasil</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faLanguage} style={{color: "#4d4d4d",}} /> Idiomas Falados:<span>Português Brasileiro, Inglês Americano</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faEarthAmericas} style={{color: "#4d4d4d",}} /> Nacionalidade:<span>Brasileiro</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faSchool} style={{color: "#4d4d4d",}} /> Educação: <span>Faculdade de Análise e Desenvolvimento de Sistemas</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faUserSecret} style={{color: "#4d4d4d",}} /> Freelance: <span>Disponível</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faStar} style={{color: "#4d4d4d",}} /> Interesses: <span>Desenvolvimento Web, Web Designer - UX UI</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faLaptopCode} style={{color: "#4d4d4d",}} /> Experiência: <span>Projetos pessoais</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faEnvelope} style={{color: "#4d4d4d",}} /> Email: <span>Marcospaulomaio2607@gmail.com</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faPhoneVolume} style={{color: "#4d4d4d",}} /> Phone: <span>55+ 2196539-9177</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faGraduationCap} style={{color: "#4d4d4d",}} /> Certificações: <a href='/certificado-cursos.pdf' download><span>40 Cursos Concluídos</span></a></p>
                    </div>

                    <div className={styles.container_button}>
                            <ZipButtonFilePtBr />
                    </div>
                </div>
            </section>
            <SectionBorderPtBr />
        </>
    )
}
